module.exports = __webpack_public_path__ + "bot-isaura.png?8f054da8dce4f8ab9ed0450952bf02f4";


//////////////////
// WEBPACK FOOTER
// ./public/images/templates/bot-isaura.png
// module id = 555
// module chunks = 16